export default {
  FAQ_btn: 'FAQ',
  impressum_btn: 'Contacts',
  contact_us_btn: 'Contact us',
  privacyPolicy_btn: 'Privacy policy'
}



// WEBPACK FOOTER //
// ./src/locale/en-US/login.js